const SupportEmailIcon = ({
  width = 20,
  height = 20,
  className = '',
  stroke,
  ...props
}: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    {...props}
  >
    <path
      d='M2.5 5.83341V14.1667C2.5 15.0834 3.25 15.8334 4.16667 15.8334H15.8333C16.75 15.8334 17.5 15.0834 17.5 14.1667V5.83341M2.99 15.3434L8.06833 10.2651M11.9667 10.3001L17.01 15.3434M2.5 5.66675C2.5 6.16675 2.75 6.58341 3.16667 6.91675L8.16667 10.3334C9.33333 11.0834 10.75 11.0834 11.9167 10.3334L16.9167 7.00008C17.25 6.58341 17.5 6.16675 17.5 5.66675C17.5 4.83341 16.8333 4.16675 16 4.16675H4C3.16667 4.16675 2.5 4.83341 2.5 5.66675Z'
      stroke={stroke || '#0098F0'}
      strokeWidth='1.3'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export { SupportEmailIcon };
